import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_SDT_LAttributed = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Syntax Directed Translations and implementation of L-Attributed syntax directed translation"
    videos={[
      "https://www.youtube.com/embed/a9pzpMH4C50",
      "https://www.youtube.com/embed/l82PgfuITWA",
      "https://www.youtube.com/embed/T0vWu3s2CsE",
      "https://www.youtube.com/embed/uvkItutUNHA",
      "https://www.youtube.com/embed/bNPX_F0x6Hc",
      "https://www.youtube.com/embed/KV01s3r9fLc",
      "https://www.youtube.com/embed/IU6eb0S4qw0",
      "https://www.youtube.com/embed/m8z55ZgoOSU",
    ]}
    takeaways={[
      { text: "Go through all the videos that are mentioned above, mostly all types are covered." },
      { text: "Doing a new question from this topic is a bit difficult, so practice as many examples possible" },
    ]}
    questions={[
      `1) Consider the following grammar for specifying binary trees (in linearized form):
BinTree -> (num BinTree, BinTree2) | ε

Extend the above grammar by defining a translation scheme such that a depth-first left-to-right traversal of a parse tree (denoting a binary tree) annotated with semantic actions will entail checking if the binary tree is ordered. A binary tree is ordered if the values of the numbers of the first subtree (BinTree1) are less than the value of the current number and the values of the numbers of the second subtree (BinTree2) are greater than the value of the current number. For instance, (2 (1 nil nil) (3 nil nil)) is ordered but (1 (2 nil nil) (3 nil nil)) is not. Note that you can use any language constructs (such as assignments, if-then-else, expressions, boolean expressions etc.) for writing the semantic rules.`,

      `2) Consider the following grammar given below.
E -> E + T | T
T -> T * F | F
F -> (E) | id

Perform syntax-directed translation to generate three-address code for arithmetic expressions. Show the annotated parse tree and the resulting three-address code for the input string "2+3*4"`,

      `3) Consider the following expression:
E = (A && B) || (C || D)
Assume short-circuit evaluation for logical AND (&&) and logical OR (||) operators. Implement a semantic analysis algorithm to evaluate the expression using short-circuit evaluation. Show the step-by-step evaluation process and the final result for the following variable assignments:
A=true, B=false, C=true, D=false`,

      `4) Suppose we have a production rule in a grammar A -> B C D. Each of the four variable/non-terminals has two attributes. 's' is a synthesized attribute and 'i' is an inherited attribute. For each set of rules below, check whether the rules are consistent with (a) an S-attributed definition, and (b) an L-attributed definition:
i. A.s = B.i + C.i
ii. A.s = B.i + C.s and D.i = A.i + B.s
iii. A.s = B.s + D.s
iv. A.s = D.i, B.i = A.s + C.s, C.i = B.s, D.i = B.i + C.i`,

      `5) Write an SDT to compute the storage layout for the given array declaration statement "float mat[3][2]".`,

      `6) Consider the syntax-directed translation given by the following grammar and semantic rules. Here N, I, F, and B are non-terminals. N is the starting non-terminal, and #, 0, and 1 are lexical tokens corresponding to input letters "#", "0" and "1", respectively. X.val denotes the synthesized attribute (a numeric value) associated with a non-terminal X. I1 and F1 denote occurrences of I and F on the right-hand side of a production, respectively. For the tokens 0 and 1, 0.val=0 and 1.val=1. Find the value computed by the translation scheme and Draw an annotated parse tree showing the detailed computation of attribute values for the given string 10#011.

N -> I # F  {N.val = I.val + F.val}
I -> I1 B  {I.val = (2 * I1.val) + B.val}
I -> B     {I.val = B.val}
F -> B F1  {F.val = 1/2 * (B.val + F1.val)}
F -> B     {F.val = 1/2 * B.val}
B -> 0     {B.val = 0.val}
B -> 1     {B.val = 1.val}`,

      `7) Explain how SDT is applied in the construction of the syntax tree for the string: 3*4-7/2. Describe how attributes are passed and computed at each node, focusing on the flow of values.`,

      `8) Use the semantic actions for array references and annotate the parse tree for x = a[b[i][j]][c[k]].`,

      `9) Explain the concept of L-attributed syntax-directed definition. Discuss the restrictions placed on inherited attributes in L-attributed grammars and how these grammars are useful in recursive descent parsing.`,

      `10) Formulate SDT for syntax tree construction for a simple desk calculator and show how the expression 2+4*5^2 is evaluated.`,

      `11) Construct a Syntax Tree for the given expression m = y + z - c / b * 34, with the help of arithmetic expression grammar and semantic actions.`,
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_SDT_LAttributed;
